import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import type { BanModal, socketBanInfo, SignInData } from '@/types';
import { useLimits } from '@/composables/useLimits';
import { usePlayerStore } from './player';

export const useAuthStore = defineStore('auth', () => {
    const { toSetTimeLimit } = useLimits();
    const playerStore = usePlayerStore();
    const player = computed(() => playerStore.player);
    const loadingFlag = ref<boolean>(false);
    const router = useRouter();
    const token = ref<string | null>(null);
    const visibleModal = ref<boolean>(false);
    const passwordResetToken = ref<string | null>(null);
    const banModalInfo = ref<BanModal>({
        type: null,
        time: null,
        modal: false
    });
    function toSetBanInfo(data: socketBanInfo, state: boolean): void {
        let type = null;
        if (data.loc) {
            if (data.loc === 'block_permanent') {
                type = 'block_permanent';
            } else if (data.loc === 'block_temporary') {
                type = 'block_temporary';
            }
        } else if (data.block_type !== undefined) {
            if (data.block_type === 2) {
                type = 'block_permanent';
            } else if (data.block_type === 0) {
                type = 'block_temporary';
            }
        }
        const time = data?.block_end ? new Date(data.block_end).toLocaleDateString() + ' - ' + new Date(data.block_end).toLocaleTimeString() : null;
        banModalInfo.value = {
            type: type as 'block_permanent' | 'block_temporary' | null,
            time,
            modal: state
        };
    }
    function toSetModal(value: boolean): void {
        visibleModal.value = value;
    }
    function toSetPasswordResetToken(value: string | null): void {
        passwordResetToken.value = value;
    }
    const awaitToSignIn = async (data: SignInData): Promise<void> => {
        try {
            const response = await axios.post('/main-api/auth/token', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });
            if (response && response.data) {
                localStorage.setItem('jwt', response.data.access_token);
                token.value = response.data.access_token;
            }
        } catch (error) {
            console.error('error', error);
            throw error;
        }
    };
    const signOut = async (): Promise<void> => {
        loadingFlag.value = true;
        if (player.value.time_limit) {
            await toSetTimeLimit({ time_limit: player.value.time_limit });
        }
        localStorage.removeItem('jwt');
        localStorage.removeItem('isNeedHideEmailConfirmationBar');
        localStorage.removeItem('isHideGoProfile');
        // localStorage.removeItem('myAppCache');
        token.value = null;
        await router.push('/');
        location.reload();
        loadingFlag.value = false;
    };

    return { passwordResetToken, toSetPasswordResetToken, token, awaitToSignIn, signOut, visibleModal, toSetModal, banModalInfo, toSetBanInfo, loadingFlag };
});
